import { useOrientation as useOrientationHook } from '@uidotdev/usehooks';

function getScreenOrientation() {
    return window.innerHeight > window.innerWidth ? 'portrait' : 'landscape';
}

export const useOrientation = () => {
  const orientation = useOrientationHook();

  return {
    angle: orientation.angle,
    type: orientation.type === 'UNKNOWN' ? getScreenOrientation() : orientation.type,
  }
};
